export const debounceIntervals = {
    panel: {
        onlineUserFlagInterval: 20000 // 20s
    }
}